<div class="ai-agent-outer ai-agent-messages-area ">
  <div class="section-title">
    <h1 class="text-black-400">AI Agent</h1>
    <div class="running-bot">
      <span>
        {{ statusFilterByGuid == null && isUnderProcessed != true ? 'No Active Case Assistant' : (isUnderProcessed ===
        true ? 'Active' : statusFilterByGuid) }}
      </span>
    </div>
  </div>
  <div class="scrollbarDesign heightScrollAiAgent"  #scrollbar [class.aiAgentbtmPading]="isUnderProcessed === false  "[style.height.px]="
        (containerHeight > 1000 && isUnderProcessed === false) ? (containerHeight - 175)
          : ( (isUnderProcessed === true && containerHeight > 700) ? (containerHeight + 26) : (containerHeight + 375) )" >
    <div class="ai-agent-box sorts-margin-box rounded-5" *ngFor="let message of AiAgentMessages">

      <div class="agent-text ">
        <i [ngClass]="getTextClass()" class="fa-regular fa-message"></i>
        {{message.questionText || 'Ai Agent'}}
        <span class="time">
          {{ message.messageOn ? (message.messageOn | date:"MMM dd, yyyy h:mm a") : '' }}
        </span>
      </div>
      <div class="agent-Content">
        {{message.answerText || 'No answer available'}}
      </div>
    </div>
  </div>
 
  <div class="text-message recieve-class" *ngIf="disableChat === true">
    <span class="thumbnail">
        <img src="../../../../assets/icons/chatbot-icon.svg" />
    </span>
    <span class="recieve-class">
        <div id="wave">
            {{timerMessage}}
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
        </div>
    </span>
  </div>
  <div class="ai-send-message" [hidden]="true">
    <div class="ai-send-inner"><input [(ngModel)]="questionText" type="text"
        class="form-control" placeholder="Ask the AI Agent about this case... ">
      <button>
        <i class="fa-regular fa-paper-plane" [class.textColorAlera]="agent == 'Alera'"
          [class.text-solis-primary-500]="agent == 'Solis'" [class.text-clario-primary-500]="agent == 'Clario'"
          [class.text-veris-primary-500]="agent == 'Veris'"
          [class.text-primary-revio-500]="agent == 'Revio'"></i>
      </button>
    </div>
  </div>
</div>